export const dateFormatter = (dateString) => {
  let gmtTime = new Date(dateString);
  let estTime = new Date(gmtTime - 5 * 60 * 60 * 1000);
  estTime = estTime.toISOString();
  const mm = estTime.slice(5, 7);
  const dd = estTime.slice(8, 10);
  const yyyy = estTime.slice(0, 4);
  return `${mm}/${dd}/${yyyy}`;
};
